import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { AuthService } from 'src/app/services/auth.service';
import { SearchPackage } from 'src/app/packages-module/models/searchPackage';
import { ToastrService } from 'ngx-toastr';
import { FilteringService } from 'src/app/services/filtering.service';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientPackageEditComponent } from 'src/app/packages-module/client-package-edit/client-package-edit.component';
import { ClientPackagePricing } from 'src/app/packages-module/models/clientPackagePrice';

@Component({
  selector: 'app-package-list',
  templateUrl: './package-list.component.html',
  styleUrls: ['./package-list.component.less']
})
export class PackageListComponent implements OnInit,OnDestroy {
  ngOnDestroy(): void {
    this.packages._searchPackages = []
  }

  constructor(public packages: SearchPackageService, 
    public auth: AuthService,
    public toast : ToastrService,
    public location: Router,
    public modalService : NgbModal) { }

  @Input() public clientId : number;
  @Input() public clientName : string;
  clientPackageOverrides : ClientPackagePricing[];
 
 public get searchPackages() : SearchPackage[] {
    var applied = this.packages.searchPackages.filter(pkg => {return pkg.clientIds.find(sp => { return sp == this.clientId })}).map((sp:SearchPackage)=>{
      if(this.clientPackageOverrides)
      {
        let override = this.clientPackageOverrides.find(spo=>{return spo.searchPackageId == sp.id});
        if(override) {
          // console.log('found an override', override);
          sp.cost = override.clientPackageCost;
        }
      }
     return sp;
  });


   var unapplied = this.packages.searchPackages.filter(pkg => {return !pkg.clientIds.find(sp => { return sp == this.clientId })}).
  //  sort((a, b) => {
  //    let AisApplied = this.packageAppliedToClient(a);
  //    let BisAppliced = this.packageAppliedToClient(b);
  //   if (AisApplied > BisAppliced) return -1;
  //   if (AisApplied < BisAppliced) return 1;
  //   return 0;
  // })
  sort((a, b) => a.name.localeCompare(b.name));

  return applied.concat(unapplied);
 }
 

  public ngOnInit(): void {
    console.log(this.clientId + ' loaded pkg list component from clients module')
    this.packages.FetchFullSearchPackagesListForUser(this.clientId);
    this.packages.GetClientSearchPackageOverrideList(this.clientId).subscribe((scc:ClientPackagePricing[]) =>{
        this.clientPackageOverrides = scc;
        console.log('loaded package overrides', this.clientPackageOverrides);
    })
  }
    


  packageAppliedToClient(pkg: SearchPackage) {
    try {
      let match = pkg.clientIds.find(sp => { return sp == this.clientId });
      return match != undefined;
    } catch (error) {
      console.debug(error);
    }
  }

  associatePackageToClient(pkg: SearchPackage) {
    if (!this.packageAppliedToClient(pkg)) {
      this.packages.AssociatePackageToClient(this.clientId,pkg.id).subscribe(
        (scc: boolean) => {
          if (scc) {
            this.toast.success(`Search Package ${pkg.name} was successfully assigned to ${this.clientName}`, 'Package Assigned!');
            pkg.clientIds.push(this.clientId);
          } else {
            this.toast.error(`Search Package ${pkg.name} encountered an error while assigning to ${this.clientName}`, 'Package Assignment Failed!', { disableTimeOut: true, closeButton: true })
          }
        },
        (err: any) => {
          this.toast.error(`Search Package ${pkg.name} encountered an error while assigning to ${this.clientName}`, 'Package Assignment Failed!', { disableTimeOut: true, closeButton: true })
        },
      )
    } else {
      this.removePackageFromClient(pkg);
    }

  }

  removePackageFromClient(pkg: SearchPackage) {
    this.packages.RemovePackageFromClient(this.clientId,pkg.id).subscribe(
      (scc: boolean) => {
        if (scc) {
          this.toast.success(`Search Package ${pkg.name} was successfully removed from client ${this.clientName}`, 'Package Removed!');
          pkg.clientIds.splice(pkg.clientIds.indexOf(this.clientId),1);
        } else {
          this.toast.error(`Search Package ${pkg.name} encountered an error while removing from client ${this.clientName}`, 'Package Removal Failed!', { disableTimeOut: true, closeButton: true })
        }
      },
      (err: any) => {
        this.toast.error(`Search Package ${pkg.name} encountered an error while removing from client ${this.clientName}`, 'Package Removal Failed!', { disableTimeOut: true, closeButton: true })
      },
    )
  }

  public viewPackage(pkg: SearchPackage, edit: boolean = false): void {
    if (edit) {
        // this.location.navigateByUrl(`packages/edit/${pkg.id}/${this.clientId}`);
        const modalRef = this.modalService.open(ClientPackageEditComponent, { centered: true, size: 'xl' })
        modalRef.componentInstance.name = 'ClientPackageEditComponent';
        modalRef.componentInstance.packageId = pkg.id;
        modalRef.componentInstance.clientId = this.clientId;
    } else {
        this.location.navigateByUrl(`packages/review/${pkg.id}`);
    }
}

}
